// The loader layout (SCR-170; legacy b4bfde902 src/layouts/LoaderLayout.vue): what the back office shows while the first
// route resolves, before it knows which layout the page takes (legacy App.vue renders it for any route without
// `meta.layout`, which in practice is only the boot). A flat card filling the window with the Radish logo animation
// (src/library/radish-loader.json, copied here unchanged) at 300 × 300, centred.
//
// The animation is fetched as an asset and its player loaded on demand, so neither weighs on the first bundle; the card
// shows at once and the radish joins it when they arrive. A player that can't run (a test's DOM) leaves the card plain.
import { useEffect, useRef } from 'react';
import radishLoaderUrl from './radish-loader.json?url';

export function LoaderLayout() {
  const box = useRef<HTMLDivElement>(null);
  useEffect(() => {
    let gone = false;
    let destroy: (() => void) | undefined;
    import('lottie-web/build/player/lottie_light')
      .then(({ default: lottie }) => {
        if (gone || box.current === null) return;
        const animation = lottie.loadAnimation({ container: box.current, renderer: 'svg', loop: true, autoplay: true, path: radishLoaderUrl });
        destroy = () => animation.destroy();
      })
      .catch(() => undefined);
    return () => {
      gone = true;
      destroy?.();
    };
  }, []);
  return (
    <div className="flex h-svh w-full items-center justify-center bg-surface" role="status" aria-label="Loading">
      <div ref={box} className="size-[300px]" aria-hidden="true" data-testid="radish-loader" />
    </div>
  );
}
